import apiClient from "../apiClient";
import { API_ROUTES } from "../../config/baseURL";

export const getCitologiaCatalogos = async () => {
  const res = await apiClient.get(API_ROUTES.citologiaCatalogos);
  return res.data;
};

export const getPacienteCitologiaPorNumero = async (numeroIdentificacion) => {
  const res = await apiClient.get(API_ROUTES.citologiaPacientePorNumero(numeroIdentificacion));
  return res.data;
};

export const getPacienteCitologiaPorTipoNumero = async (tipoId, numeroIdentificacion) => {
  const res = await apiClient.get(API_ROUTES.citologiaPacientePorTipoNumero(tipoId, numeroIdentificacion));
  return res.data;
};

export const getCitologiaHistorico = async (autoid) => {
  const res = await apiClient.get(API_ROUTES.citologiaHistorico(autoid));
  return res.data;
};

export const getCitologiaDetalle = async (idCitologia) => {
  const res = await apiClient.get(API_ROUTES.citologiaDetalle(idCitologia));
  return res.data;
};

export const createCitologia = async (payload) => {
  const res = await apiClient.post(API_ROUTES.citologia, payload);
  return res.data;
};

export const updateCitologia = async (payload) => {
  const res = await apiClient.put(API_ROUTES.citologia, payload);
  return res.data;
};
